"use client"

import { useState } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navbar from "./components/Navbar/Navbar"
import Footer from "./components/Footer/Footer"
import Home from "./pages/Home/Home"
import About from "./pages/About/About"
import Awards from "./pages/Awards/Awards"
import Projects from "./pages/Projects/Projects"
import Legislative from "./pages/Legislative/Legislative"
import Gallery from "./pages/Gallery/Gallery"
import PollingUnits from "./pages/PollingUnits/PollingUnits"
import FAQ from "./pages/FAQ/FAQ"
import Contact from "./pages/Contact/Contact"
import "./App.css"
import ProtectedRoute from "./Protectroute"

function App() {
  const [language, setLanguage] = useState("en")

  return (
    <ProtectedRoute>
        <Router>
      <div className="App">
        <Navbar language={language} setLanguage={setLanguage} />
        <main>
          <Routes>
            <Route path="/" element={<Home language={language} />} />
            <Route path="/about" element={<About language={language} />} />
            <Route path="/awards" element={<Awards language={language} />} />
            <Route path="/projects" element={<Projects language={language} />} />
            <Route path="/legislative" element={<Legislative language={language} />} />
            <Route path="/gallery" element={<Gallery language={language} />} />
            <Route path="/polling" element={<PollingUnits language={language} />} />
            <Route path="/faq" element={<FAQ language={language} />} />
            <Route path="/contact" element={<Contact language={language} />} />
          </Routes>
        </main>
        <Footer language={language} />
      </div>
    </Router>
    </ProtectedRoute>
  )
}

export default App
